import { useTranslation } from '@/i18n';
import { useScrollReveal } from './useScrollReveal';

const bulletKeys = [
  'landing.forCustomers.bullet1',
  'landing.forCustomers.bullet2',
  'landing.forCustomers.bullet3',
];

export function ForCustomers() {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  return (
    <section
      ref={sectionRef}
      className="landing-reveal py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              {t('landing.forCustomers.title')}
            </h2>
            <ul className="space-y-4">
              {bulletKeys.map((key) => (
                <li key={key} className="flex items-start gap-3">
                  <svg
                    className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-gray-600">{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-shrink-0">
            <span
              className="inline-flex items-center px-6 py-3 text-base font-medium text-gray-400 rounded-lg border border-gray-200 min-h-[44px] cursor-default"
              aria-label={t('landing.forCustomers.comingSoon')}
            >
              {t('landing.forCustomers.cta')}
              <svg
                className="w-4 h-4 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
